import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { fieldWrapperStyles } from "./field-wrapper.css.ts";

@customElement("wow-field-wrapper")
export class WowFieldWrapper extends LitElement {
  static override styles = [fieldWrapperStyles];

  @property({ type: String }) inputType?: "radio" | "checkbox" | "switch";
  @property({ type: Boolean }) row = false;

  override render() {
    return html`
      <div
        class=${classMap({
          "field-wrapper": true,
          [this.inputType as string]: !!this.inputType,
        })}
      >
        <div class="title">
          <slot name="label"></slot>
          <slot name="help"></slot>
        </div>

        <div class="control"><slot name="control"></slot></div>

        <slot name="error"></slot>
      </div>
    `;
  }
}
